import renewalApplicationReducer from "./renewalApplicationReducer";

const renewalApplicationReducers = {
    renewalApplication: renewalApplicationReducer,
}

export default renewalApplicationReducers;